<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kLOb0R/tc-custom/9781497613577.jpg?1737197408162" alt="This image is the cover for the book Castle Kidnapped, Castle Perilous"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Castle Kidnapped, Castle Perilous
      </h1>
      <p class="bookDescription body article font2">
        <b>When the magical Castle Perilous goes haywire, guests find themselves venturing into bizarre other worlds that could bring the castle crumbling down.</b><br/><br/> Castle Perilous is a magic castle full of mystery and adventure, but sometimes even magic castles can go awry. This particular castle has the power to send its guests to 144,000 alternate worlds, each a fantastic voyage to the unknown. But each voyage seems to backfire. Computer whiz kid Jeremy is stuck on a planet of golf-playing dinosaurs. Gentrified Gene finds himself on a planet overrun with amazon women where the queen has taken a particular shine to him and only the Lord of the Castle Incarnadine can stop this witty madness from shaking Castle Kidnapped to its foundations. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John DeChancie
      </h2>
      
      <p class="authorDescription body article">John DeChancie is a popular author of numerous science fiction and fantasy novels, including the hugely entertaining&#160;Castle&#160;series and the&#160;Starrigger&#160;trilogy. He grew up near Pittsburgh, Pennsylvania, and now lives in Los Angeles, California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?367de367